<h2 mat-dialog-title>DETALLE DE PEDIDO</h2>
<mat-dialog-content class="mat-typography">
  <form [formGroup]="autorizaPedidoForm" (ngSubmit)="procesaAutorizacion()">
    <div class="row">
      <div class="col s12 m6 l6" *ngIf="loadingTiposAutorizacion">
        <mat-spinner [diameter]="40" style="top: 15px"></mat-spinner>
      </div>
      <div class="col s12 m6 l6" *ngIf="!loadingTiposAutorizacion">
        <mat-form-field>
          <mat-label>TIPO AUTORIZACIÓN</mat-label>
          <mat-select formControlName="idTipoAutorizacion">
            <mat-option
              *ngFor="let item of tiposAutorizacion"
              [value]="item.id"
            >
              {{ item.valor }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col s12 m6 l6">
        <mat-form-field class="example-full-width">
          <mat-label>OBSERVACIÓN</mat-label>
          <textarea formControlName="observacion" matInput></textarea>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col s12 m6 l6">
        <button
          type="submit"
          [disabled]="!autorizaPedidoForm.valid || loadingCrearAutorizacion"
          mat-raised-button
          color="accent"
        >
          Procesar
        </button>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    mat-raised-button
    [mat-dialog-close]="dataModified"
    color="primary"
    cdkFocusInitial
  >
    Cerrar
  </button>
</mat-dialog-actions>
